<template>
    <div>
        <div class="base-search-container">
            <swb-query-sort-area :config="queryConfig" :queryKey="queryKey" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>

        <div class="column-layout">
            <div class="table-layout" v-if="multiSelect">
                <el-table :data="fusedGoodsCatList" border ref="multipleTable" style="width: 100%" @selection-change="handleSelectionChange">
                    <el-table-column v-if="multiSelect" type="selection" width="55"></el-table-column>
                    <el-table-column prop="catName" label="分类名称" align="left">
                        <template slot-scope="rows">
                            <span>{{rows.row.catName}}<span v-if="showDesc && rows.row.desc != null">&nbsp;({{rows.row.desc}})</span></span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="goodsCat1Name" label="1级分类名称" align="left"></el-table-column>
                    <el-table-column prop="goodsCat2Name" label="2级分类名称" align="left"></el-table-column>
                    <el-table-column prop="createTime" label="创建时间" width="150" align="left"></el-table-column>
                </el-table>
            </div>
            <div class="table-layout" v-else="">
                <el-table :data="fusedGoodsCatList" border style="width: 100%" @current-change="handleCurrentChange">
                    <el-table-column width="55">
                        <template slot-scope="rows">
                            <div class="copy-radio" :class="{'circle' : hashCheckedRow(rows.row)}">
                                <div class="circle-dot"></div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="catName" label="分类名称" align="left">
                        <template slot-scope="rows">
                            <span>{{rows.row.catName}}<span v-if="showDesc && rows.row.desc != null">&nbsp;({{rows.row.desc}})</span></span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="goodsCat1Name" label="1级分类名称" align="left"></el-table-column>
                    <el-table-column prop="goodsCat2Name" label="2级分类名称" align="left"></el-table-column>
                    <el-table-column prop="createTime" label="创建时间" width="150" align="left"></el-table-column>
                </el-table>
            </div>
            <div class="block pagination-layout" v-if="totalCount > 10">
                <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../../src/app.conf'

    import goodsCategApi from '../../api/goodsCateg'
    import userApi from '../../api/user'

    let searchConfigData = {
        "queryFields": [
            {
                "type": "Text",
                "label": "分类名称",
                "code": "catName",
                "basic": true,
                "valueType": "String"
            }
        ],
        "sortFields": []
    };

    export default {
        name: 'swb-fused-goods-cat-select',
        props: {
            multiSelect: {
                type: Boolean,
                default: true
            },
            initCheckedItem: {
                type: Object,
                default: null
            },
            initCheckedItems: {// 多选的时候传入
                type: Array,
                default: function () {
                    return [];
                }
            },
            noPostFilters: { // 是否不要进行岗位权限过滤
                type: Boolean,
                deafult: false,
            }
        },
        data: function () {
            return {
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                fusedGoodsCatList: [],
                //
                queryConfig: null,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                //复选信息
                checkedIdsX: [],
                checkedIdMap: {},
                checkedDelay: 100,
                checkedIniting: false,
                checkedTblRefId: 'multipleTable',
                checkedList: [],
                checkInfo: {},
                showDesc: false
            }
        },
        created: function () {
            let self = this;
            self.pageSize = self.pageSizes.first();
            // self.name = self.$route.query.name || null;
            //----------------------搜索排序----------------------------
            //查询排序配置信息
            let queryConfig = searchConfigData || {};
            //
            this.queryConfig = queryConfig;
            if(this.multiSelect == true) {
                self.initCheckedItems.forEach(function (item) {
                    self.checkedIdsX.add(item.catId);
                    //
                    self.checkedIdMap[item.catId + ''] = merge({}, item);
                });
            }
            else {
                if(self.initCheckedItem != null) {
                    let item = self.initCheckedItem;
                    //
                    self.checkedIdsX.add(item.catId);
                    //
                    self.checkedIdMap[item.catId + ''] = merge({}, item);
                }
            }
            //
            userApi.getUserInfoByContext({}, function (result) {
                if(result.type == "info") {
                    let merchantId = result.data.scopeEntity.id;
                    // self.showDesc = merchantId == 259;
                    self.getFusedGoodsCatList();
                } else {
                    self.$message.error(result.message);
                }
            });
        },
        methods: {
            addCheckId: function (item, val) {
                let catId = item.catId;
                if(!this.multiSelect) {
                    this.checkedIdsX = [];
                    this.checkedIdMap = {};
                }
                if(!this.checkedIdsX.contains(catId)) {
                    this.checkedIdsX.add(catId);
                    this.checkedIdMap[catId + ''] = item;
                    return item;
                }
                return null;
            },
            delCheckId: function (catId) {
                let self = this;
                if(self.checkedIdsX.contains(catId)) {
                    self.checkedIdsX.remove(catId);
                    //
                    delete this.checkedIdMap[catId + ''];
                    //
                    return catId;
                }
                return null;
            },
            handleCurrentChange: function (val) {
                this.handleSelectionChange([val]);
            },
            handleSelectionChange: function (selRows) {
                let self = this;
                if(self.checkedIniting) {
                    return;
                }
                let allIds = self.fusedGoodsCatList.pluck("catId");
                let selIds = selRows.pluck("catId");
                selRows.forEach(function (item, index) {
                    selIds.add(item.catId);
                    //
                    self.addCheckId(item, selRows[index]);
                });

                let lesIds = Utils.compareArrays(selIds, allIds)["less"];
                lesIds.forEach(function (catId, index) {
                    self.delCheckId(catId);
                });
            },
            restoreSelRows(dataRows, tblRefId, idProp){
                let self = this;
                self.checkedIniting = true;
                idProp = idProp || "catId";
                let allIds = dataRows.pluck(idProp);
                let selIds = Utils.compareArrays(allIds, this.checkedIdsX)["same"];
                selIds.forEach(function (catId) {
                    self.toggleListRowById(dataRows, tblRefId, idProp, catId);
                });
                //
                setTimeout(function () {
                    self.checkedIniting = false;
                }, 100);
            },
            hashCheckedId(id){
                return this.checkedIdsX.contains(id);
            },
            hashCheckedRow(row){
                let checkId = row["catId"];
                return this.checkedIdsX.contains(checkId);
            },
            toggleListRowById(dataRows, tblRefId, idProp, idVal){
                let self = this;
                //
                idProp = idProp || "catId";
                let refTbl = self.$refs[tblRefId];
                let theRow = dataRows.find(function (row, idx) {
                    return row[idProp] == idVal;
                });
                if(theRow != null) {
                    refTbl.toggleRowSelection(theRow);
                }
            },
            queryHandler(queryModel){
                this.queryModel = queryModel;
                if(this.checkedIniting) {
                    return;
                } else {
                    this.checkedIniting = true;
                }
                this.pageNumber = 1;
                //
                this.getFusedGoodsCatList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                //
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                if(this.checkedIniting) {
                    return;
                } else {
                    this.checkedIniting = true;
                }
                //
                this.pageNumber = val;
                //
                this.getFusedGoodsCatList();
            },

            getFusedGoodsCatList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.noPostFilters = self.noPostFilters;
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                goodsCategApi.getMerchtFusedGoodsCatPageList(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let data = result.data;
                        let fusedGoodsCatList = data.rows || [];
                        for(let i = 0; i < fusedGoodsCatList.length; i++) {
                            let fusedGoodsCat = fusedGoodsCatList[i];
                            let fullName = fusedGoodsCat.fullName;
                            let fullNames = fullName.split("\\");
                            fusedGoodsCat.goodsCat1Name = fullNames[0];
                            fusedGoodsCat.goodsCat2Name = fullNames[1];
                        }
                        self.fusedGoodsCatList = fusedGoodsCatList;
                        self.totalCount = data.pagination.totalCount;
                        setTimeout(function () {
                            self.restoreSelRows(self.fusedGoodsCatList, self.checkedTblRefId, 'catId');
                        }, self.checkedDelay);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getGoodCat(index){
                let self = this;
                let catId = self.fusedGoodsCatList[index].catId;
                goodsCategApi.getGoodCat({id: catId}, function (descReuslt) {
                    self.fusedGoodsCatList[index].desc = descReuslt.data.desc;
                    self.fusedGoodsCatList = Utils.merge([], self.fusedGoodsCatList);
                    //

                });
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                result.type = 'info';
                //
                let checkedIdsX = self.checkedIdsX;
                if(!Utils.isNoB(checkedIdsX) && checkedIdsX.length > 0) {
                    if(this.multiSelect) {   // 多选
                        result.data = checkedIdsX.map(function (catId) {
                            return self.checkedIdMap[catId + ''];
                        });
                    } else {
                        // 单选
                        let checkedId = self.checkedIdsX.first();
                        if(checkedId != null) {
                            result.data = this.checkedIdMap[checkedId + ''];
                        }
                    }
                } else {
                    result.type = 'warn';
                    result.message = "请选择分类信息";
                }
                return result;
            }

        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/categ/MerchtFusedGoodsCatForSelect.vue